module.exports = __webpack_public_path__ + "img/coinbankB21.9678a449.jpg";